import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { TypeOf, z } from 'zod';

import { Card } from '@repo/ui/Card';
import { Form } from '@repo/ui/Form';
import { TextInputField } from '@repo/ui/Form';
import { registerInput, useZodForm } from '@repo/hooks/useZodForm';

interface ContactDetailsFormProps {
  userId: string;
  first_name: string;
  last_name: string;
  email: string;
  refetch: () => void;
}

const updateUserFormSchema = z.object({
  first_name: z.string().min(2, { message: 'First name must contain at least 2 characters.' }),
  last_name: z.string().min(2, { message: 'Last name must contain at least 2 characters.' }),
  email: z.string().email({ message: 'Please submit a valid email address.' }),
});
type UpdateUserFormParams = TypeOf<typeof updateUserFormSchema>;

const ContactDetailsForm = ({
  userId,
  email,
  first_name,
  last_name,
  refetch,
}: ContactDetailsFormProps) => {
  // Mutation
  const UPDATE_USER = gql`
    mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
      updateUser(id: $id, input: $input) {
        user {
          id
          name
          first_name
          last_name
          email
        }
      }
    }
  `;

  const client = useApolloClient();
  const onSubmit = async (input: UpdateUserFormParams) => {
    await client.mutate({
      mutation: UPDATE_USER,
      variables: {
        id: userId,
        input,
      },
    });

    refetch();
  };
  const form = useZodForm({
    schema: updateUserFormSchema,
    onSubmit,
  });

  return (
    <>
      <Card title="Contact details">
        <Form {...form}>
          <TextInputField
            label="First Name"
            defaultValue={first_name}
            readOnly
            disabled
            {...registerInput(form, 'first_name')}
          />
          <TextInputField
            label="Last Name"
            defaultValue={last_name}
            readOnly
            disabled
            {...registerInput(form, 'last_name')}
          />
          <TextInputField
            type="email"
            label="Email"
            readOnly
            disabled
            defaultValue={email}
            {...registerInput(form, 'email')}
          />

          {/* <div className="w-full">
            <Button type="submit">Save changes</Button>
          </div> */}
          <Form.Success>Contact details successfully updated.</Form.Success>
          <Form.Error>
            Unable to update contact details. Please try again later or contact support if error
            persists.
          </Form.Error>
        </Form>
      </Card>
    </>
  );
};

export default ContactDetailsForm;
